module.exports = __webpack_public_path__ + "static/media/product_hierarchy.7efa9428.png";